import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { UserPreferences, UpdateUserPreferencesData } from '@/types';

export function useUserPreferences() {
  return useQuery({
    queryKey: ['user-preferences'],
    queryFn: async () => {
      const response = await api.get<UserPreferences>('/users/me/preferences');
      return response.data;
    },
  });
}

export function useUpdateUserPreferences() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateUserPreferencesData) => {
      const response = await api.patch<UserPreferences>('/users/me/preferences', data);
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.setQueryData(['user-preferences'], data);
    },
  });
}
